import React from "react";
import { motion } from "framer-motion";
import { CheckCircle, Shield, Zap, Heart } from "lucide-react";
import "./MediaShowcaseSection.css";

const MediaShowcaseSection = () => {
  return (
    <section className="media-showcase-section">
      <div className="container">
        <div className="showcase-grid">
          {/* Left Side: Video */}
          <motion.div 
            className="showcase-media"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
          >
            <div className="video-wrapper">
              <video 
                src="/medico.mp4" 
                controls 
                autoPlay 
                muted 
                loop 
                poster="/medico.png"
                className="showcase-video"
              >
                Your browser does not support the video tag.
              </video>
              <div className="media-glow"></div>
            </div>
          </motion.div>

          {/* Right Side: Details */}
          <motion.div 
            className="showcase-details"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <div className="eyebrow">
              <Heart size={14} className="icon-cyan" />
              <span>PLATFORM_SHOWCASE</span>
            </div>
            <h2 className="section-title">
              Experience the Future of <span className="gradient-text">Clinical Intelligence</span>
            </h2>
            <p className="section-subtitle">
              Watch how Medico.in transforms raw biometric data into actionable clinical insights in real-time. Our platform bridges the gap between hardware and healthcare.
            </p>

            <div className="features-stack">
              <div className="feature-item">
                <div className="feature-icon-wrap">
                  <Zap size={20} />
                </div>
                <div className="feature-text">
                  <h3>Sub-Second Latency</h3>
                  <p>Data packets move from sensor to dashboard in less than 100ms, ensuring immediate response capability.</p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon-wrap">
                  <Shield size={20} />
                </div>
                <div className="feature-text">
                  <h3>Bank-Grade Security</h3>
                  <p>All telemetry data is encrypted in transit and at rest, complying with strict healthcare privacy standards.</p>
                </div>
              </div>

              <div className="feature-item">
                <div className="feature-icon-wrap">
                  <CheckCircle size={20} />
                </div>
                <div className="feature-text">
                  <h3>Multi-Device Sync</h3>
                  <p>Connect multiple sensors simultaneously for a complete picture of patient health on a single HUD.</p>
                </div>
              </div>
            </div>

            <div className="showcase-stats">
              <div className="stat-node">
                <span className="stat-val">99.9%</span>
                <span className="stat-lbl">Uptime</span>
              </div>
              <div className="stat-node">
                <span className="stat-val">&lt;100ms</span>
                <span className="stat-lbl">Latency</span>
              </div>
              <div className="stat-node">
                <span className="stat-val">24/7</span>
                <span className="stat-lbl">Monitoring</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default MediaShowcaseSection;
